import { styled } from 'linaria/react';
import { StyledItem as ImportItem } from 'components/AddContent/Menu/styled';

export const StyledItem = styled(ImportItem)`
  padding-top: 10px;
`;
